"use strict";
/// <reference path="../types/Jsts.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Polygon_1 = __importDefault(require("./Polygon"));
var Geometry_1 = __importDefault(require("./Geometry"));
var GeometryType_1 = require("./GeometryType");
var GeometryCollectionBase_1 = __importDefault(require("./GeometryCollectionBase"));
var MultiPolygon = /** @class */ (function (_super) {
    __extends(MultiPolygon, _super);
    function MultiPolygon(polygon) {
        return _super.call(this, polygon) || this;
    }
    Object.defineProperty(MultiPolygon.prototype, "type", {
        get: function () {
            return GeometryType_1.GeometryType.MultiPolygon;
        },
        enumerable: true,
        configurable: true
    });
    MultiPolygon.prototype._ts = function () {
        return Geometry_1.default._factory.createMultiPolygon(this.children.map(function (l) { return l._ts(); }));
    };
    MultiPolygon.prototype._clone = function (convert) {
        return new MultiPolygon(this._cloneChildren(convert));
    };
    MultiPolygon._from = function (multiPolygon) {
        var geom = new MultiPolygon();
        var polygonCount = multiPolygon.getNumGeometries();
        for (var i = 0; i < polygonCount; i++) {
            geom.children.push(Polygon_1.default._from(multiPolygon.getGeometryN(i)));
        }
        return geom;
    };
    return MultiPolygon;
}(GeometryCollectionBase_1.default));
exports.default = MultiPolygon;
